module.exports = __webpack_public_path__ + "img/0a172e4e31519f1001e044deb1a641c8.png";